/**
 * 로더 관련 이벤트 상수
 */

// 로딩 스피너 이벤트
export const SHOW_LOADER = 'SHOW_LOADER';
export const CLOSE_LOADER = 'CLOSE_LOADER';

// 에러 모달 이벤트
export const SHOW_ERROR = 'SHOW_ERROR';
export const CLOSE_ERROR = 'CLOSE_ERROR';

// 경고 모달 이벤트
export const SHOW_WARNING = 'SHOW_WARNING';
export const CLOSE_WARNING = 'CLOSE_WARNING';